var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"top"},_vm._l((_vm.notifications),function(mynotification){return _c('NotificationBar',{key:mynotification.id,class:_vm.isPhone ? 'top_notification_small' : 'top_notification',attrs:{"notification":mynotification}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }